import * as React from 'react';
import styled from '@emotion/styled';
import SummariesTable from '../tables/SummariesTable';
import { tableViewModel } from '../models/views/tableViewModel';

const SummaryView = styled.div`
  background: #fff;
  box-shadow: 20px 0 0 0 #fff;
  display: block;
  font-size: 1.2rem;
`;
const SummarySection = styled.section`
  width: 33%;
  display: inline-grid;
`;

interface Props {
  data: {
    physicalVMsData: tableViewModel[];
    physicalHostsData: tableViewModel[];
    physicalHostsStatsData: tableViewModel[];
  };
  noData: boolean;
}
class PhysicalSummaryBody extends React.Component<Props> {
  render() {
    return (
      <SummaryView>
        <SummarySection>
          <SummariesTable title="" titleIcon="" data={this.props.data.physicalHostsData} />
        </SummarySection>

        <SummarySection>
          <SummariesTable title="" titleIcon="" data={this.props.data.physicalHostsStatsData} />
        </SummarySection>

        <SummarySection>
          <SummariesTable title="" titleIcon="" data={this.props.data.physicalVMsData} />
        </SummarySection>
      </SummaryView>
    );
  }
}
export default PhysicalSummaryBody;
